import { SUPPORTED_COUNTRY } from './constants';
// This method is similar to salesforceId env in the graphql api
// This purpose is to return salesforceId

export const getSalesforceId = (countryCode: SUPPORTED_COUNTRY) => {
  if (countryCode === SUPPORTED_COUNTRY.US) {
    return 'NA';
  }
  return countryCode;
};
